import { type Route } from 'next'
import { ReadonlyURLSearchParams } from 'next/navigation'

export const typeRoute = <T extends string>(
  route: Route<T>,
  params?: string | Record<string, string | number | undefined | null> | ReadonlyURLSearchParams | URLSearchParams,
): Route<string> => {
  if (typeof params === 'object' && params) {
    let searchParams = new URLSearchParams()
    if (route.includes('?')) {
      searchParams = new URLSearchParams(route.split('?')[1])
      route = route.split('?')[0] as any
    }
    if (params instanceof URLSearchParams) {
      params = Object.fromEntries(params.entries())
    }
    for (let key in params) {
      if (params[key] === undefined || params[key] === null) continue
      if (typeof params[key] === 'number') searchParams.set(key, params[key].toString())
      else searchParams.set(key, params[key]!)
    }
    const searchQuery = searchParams.toString()
    if (searchQuery) return `${route}?${searchQuery}` as any
  }
  if (typeof params === 'string') {
    return (route + params) as any
  }
  return route as Route<string>
}
